import { facadeApi } from 'api'

export const approveTenantAccessRequestsApi = (ids: string[]) =>
  facadeApi.patch('/access-requests/approve/bulk', { ids })
